<template>
  <div class="" v-if="isPropertyLoading || isTrainingModuleLoading"><Loading /></div>

  <div v-else>
    <BethsLayout :layoutTitle="`${trainingTest?.title} - ${property?.name}`">
      <div v-if="property.isTrainingEnabled">
        <div v-if="answers">
          <h1 class="mt-2 text-xl">{{ trainingTest.title }}</h1>
          <h2 class="mb-8 font-serif text-base text-gray-400">
            Test Question {{ questionNumber }} of {{ testQuestions.length }}:
          </h2>
          <p class="font-bold text-2xl mb-12">{{ question.text }}</p>
          <BaseRadioGroup
            :options="answers"
            class="text-lg m-4 p-4"
            vertical
            name="question"
            v-model="userAnswer"
          />
          <button
            class="mt-4 p-4 bg-blue-800 text-gray-50 border rounded-md hover:bg-blue-200 hover:text-gray-900 disabled:bg-gray-300"
            @click="submitClick"
            :disabled="userAnswer?.length == 0"
          >
            Submit Answer
          </button>
        </div>
        <div v-else>
          <p class="pb-8">No test for this module.</p>
          <button
            class="mt-4 p-2 text-sm bg-blue-100 border rounded-md hover:bg-blue-200"
            @click="exitModule"
          >
            Exit Module
          </button>
        </div>
      </div>
      <div v-else>
        <h1>Training Not Enabled</h1>
      </div>
    </BethsLayout>
  </div>
</template>

<script setup lang="ts">
import { MetricCaptureNames, useMetrics } from "../helpers/metrics";
import { NameValue } from "../sharedTypes";
import { useBldgStore } from "../store/bldgStore";
import { useTrainingStore } from "../store/trainingStore";
import { useUserStore } from "../store/userStore";

const router = useRouter();
const route = useRoute();
const bldgStore = useBldgStore();
const trainingStore = useTrainingStore();
const userStore = useUserStore();
const metrics = useMetrics();

var isTrainingModuleLoading = ref(true);
var trainingTest = computed(() => trainingStore.selectedModuleTests?.at(0));
var testQuestions = computed(() => trainingStore.selectedTestQuestions);
var questionNumber = ref(-1);
var question = computed(() => testQuestions.value[questionNumber.value - 1]);
var answers = computed(() => {
  var question = testQuestions.value[questionNumber.value - 1];
  return question?.answers?.map((a) => ({ name: a.text, value: a.text } as NameValue));
});

var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);

onMounted(loadData);
watch(route, loadData);
async function loadData() {
  isTrainingModuleLoading.value = true;
  redirectIfNotLoggedIn();
  if (route.params.questionNumber && typeof route.params.questionNumber == "string") {
    questionNumber.value = Number.parseInt(route.params.questionNumber);
  }
  if (route.params.moduleId && typeof route.params.moduleId === "string") {
    let trainingModuleId = Number.parseInt(route.params.moduleId);
    await trainingStore.getTestsByTrainingModule(trainingModuleId);
    if (trainingStore.selectedModuleTests[0])
      await trainingStore.getQuestionsByTest(trainingStore.selectedModuleTests[0].testId);
  }
  isTrainingModuleLoading.value = false;
}

var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);
watch(isUserLoadedFromServer, redirectIfNotLoggedIn);
function redirectIfNotLoggedIn() {
  if (property.value && isUserLoadedFromServer.value && !userStore.isLoggedIn)
    router.push(`/${property.value.siteCode}/login?returnUrl=training`);
}

var userAnswer = ref("");

function exitModule() {
  router.push(`../../../`);
}

function submitClick() {
  question.value.answers.every((answer) => {
    if (answer.text === userAnswer.value) {
      trainingStore.clientAnswers[questionNumber.value - 1] = answer.answerId;
      return false;
    }
    return true;
  });

  metrics.capture(MetricCaptureNames.QuestionAnswered);

  router.push(`./${questionNumber.value}/result`);
}
</script>
